export enum StartActivityPropertyKeys {
    Id = "Id",
    Name = "Name",
    NameLanguage = "NameLanguage",
    ClrTypeID = "ClrTypeID",
    /**
     * 是否允许选择目标节点
     */
    SelectTargetAble = 'SelectTargetAble',
    /**
     * 跳转范围
     */
    JumpScope = 'JumpScope',
    ExecuteForms = 'ExecuteForms',
    wf_ExecuteForms_PC = 'wf_ExecuteForms_PC',
    wf_ExecuteForms_Mobile = 'wf_ExecuteForms_Mobile',
    otherAssignNodes = 'otherAssignNodes',
    otherAssignActivities = 'otherAssignActivities',
    otherAssignActivityNodeInfos = 'OtherAssignActivityNodeInfos',
    sendBackedTask = "sendBackedTask"
}